"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFavorites = exports.favoritesContextDefaultValue = exports.favoritesContext = exports.Provider = void 0;
var _react = require("react");
/* istanbul ignore next */
const booleanFunctionDefaultValue = () => false;
/* istanbul ignore next */
const voidFunctionDefaultValue = () => {};
/* istanbul ignore next */
const asyncVoidFunctionDefaultValue = async () => {};
/* istanbul ignore next */
const stringArrayFunctionDefaultValue = () => [];
/* istanbul ignore next */
const undefinedFunctionDefaultValue = () => undefined;
const favoritesContextDefaultValue = exports.favoritesContextDefaultValue = {
  initialized: false,
  lastUsedProductCode: '',
  lastUsedProductCodeInLists: [],
  lists: [],
  maximumAllowedPersonalLists: 0,
  createList: voidFunctionDefaultValue,
  deleteList: voidFunctionDefaultValue,
  editList: voidFunctionDefaultValue,
  getList: undefinedFunctionDefaultValue,
  getProductListIds: stringArrayFunctionDefaultValue,
  isProductInList: booleanFunctionDefaultValue,
  isProductInLists: booleanFunctionDefaultValue,
  onFavoritesClick: voidFunctionDefaultValue,
  openSnackbar: voidFunctionDefaultValue,
  requestLists: voidFunctionDefaultValue,
  toggleProductInLists: asyncVoidFunctionDefaultValue,
  toggleProductsInLists: asyncVoidFunctionDefaultValue,
  updateLists: voidFunctionDefaultValue
};
const favoritesContext = exports.favoritesContext = /*#__PURE__*/(0, _react.createContext)(favoritesContextDefaultValue);
const {
  Provider
} = favoritesContext;

/** Returns the favorites context for logged-in users. */
exports.Provider = Provider;
const useFavorites = () => (0, _react.useContext)(favoritesContext);
exports.useFavorites = useFavorites;
//# sourceMappingURL=favoritesContext.js.map